import React from "react";
import { mergeStyleSets } from "@fluentui/react";

const getClassNames = () =>
  mergeStyleSets({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      margin: "8px 0",
    },
  });
const MainTab = () => {
  let { root } = getClassNames();

  return <div className={root}></div>;
};

export default MainTab;
